import axios from 'axios'

export default {
  namespaced: true,
  state: {
    exerciseData: {},
    dialogues: []
  },
  mutations: {
    CLEAR_STATE: (state) => {
      state.exerciseData = {};
      state.dialogues = [];
    },
    LOAD_DATA: (state, result) => {
      state.exerciseData = result.exerciseData;
      state.dialogues = result.dialogues;
    },
  },
  actions: {
    loadData: ({commit}, exerciseId) => {
      return new Promise((resolve, reject) => {
        axios({
          method: 'post',
          url: `${process.env.VUE_APP_SERVER_URL}loadDialogues`,
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token') 
          },
          data: {
            exerciseId
          }
        }).then(result => {
          commit('LOAD_DATA', result.data);
          resolve();
        }).catch(err => {
          reject(err.response.data.error);
        })
      })
    },
    clear: ({commit}) => {
      commit('CLEAR_STATE');
    }
  },
  getters: {
    getTitle: (state) => {
      return state.exerciseData.title;
    },
    getDialogues: (state) => {
      return state.dialogues;
    },
    getExerciseData: (state) => {
      return state.exerciseData;
    }
  }
}